export const ADD_ACCOUNT_NOTE = 'addAccountNote'
export const ADD_CAR_NOTE = 'addCarNote'
export const ADD_CREDITS = 'addCredits'
export const ADD_PETROL_CARD = 'addPetrolCard'
export const ADD_RESERVATION_NOTE = 'addReservationNote'
export const ADD_SMARTCARD = 'addSmartcard'
export const ADD_TICKET_PRIORITY = 'addTicketPriority'
export const APPROVE_APPLICATION = 'approveApplication'
export const ASSIGN_SMARTCARD = 'assignSmartcard'
export const BLACKLIST_MEMBER = 'blacklistMember'
export const UN_BLACKLIST_MEMBER = 'unblacklistMember'
export const CANCEL_LOT_RELOCATION = 'cancelLotRelocation'
export const CANCEL_PETROL_CARD = 'cancelPetrolCard'
export const CANCEL_RESERVATION = 'cancelReservation'
export const CAPTURE_HELD_CHARGE = 'captureHeldCharge'
export const CAPTURE_CARD = 'captureCard'
export const CLEAR_ADMIN_REQUEST = 'clearAdminRequest'
export const CLEAR_MODALS = 'clearModals'
export const CHANGE_NAVIGATION = 'changeNavigation'
export const CHANGE_PASS_USER = 'changePassUser'
export const CHANGE_PLAN_USER = 'changePlanUser'
export const CHARGE_ACCOUNT = 'chargeAccount'
export const CHARGE_DRIVER = 'chargeDriver'
export const CHARGE_MEMBERSHIP = 'chargeMembershipFee'
export const CHARGE_SETUP = 'chargeSetup'
export const CHECK_APPLICATION = 'checkApplication'
export const CLOSE_LOT = 'closeLot'
export const CLOSE_MODAL = 'closeModal'
export const CLOSE_MODAL_FORM = 'closeModalForm'
export const CLOSE_TICKET = 'closeTicket'
export const CLOSE_FORM = 'closeForm'
export const COMPLETE_LOT_RELOCATION = 'completeLotRelocation'
export const CREATE_PENDING_CHARGE = 'createPendingCharge'
export const CREATE_RESERVATION_CHARGE = 'createReservationCharge'
export const DECLINE_APPLICATION = 'declineApplication'
export const DELETE_ACCOUNT_MESSAGE = 'deleteAccountMessage'
export const DELETE_DASHBOARD_MESSAGE = 'deleteDashboardMessage'
export const DELETE_APPLICATION = 'deleteApplication'
export const DELETE_CAR_RESTRICTION = 'deleteCarRestriction'
export const DELETE_CREDIT_CARD = 'deleteCreditCard'
export const DELETE_SMARTCARD = 'deleteSmartcard'
export const DELETE_TICKET = 'deleteTicket'
export const DISMISS_NOTIFICATION = 'dismissNotification'
export const DISMISS_NOTIFICATIONS = 'dismissNotifications'
export const DOWNLOAD_WELCOME_LETTER = 'downloadWelcomeLetter'
export const EDIT_APPLICATION = 'editApplication'
export const EDIT_CAR = 'editCar'
export const EDIT_CREDIT_CARD_NICKNAME = 'editCreditCardNickname'
export const EDIT_CREDIT_CARD_TYPE = 'editCreditCardType'
export const EDIT_RESERVATION = 'editReservation'
export const EDIT_SMARTCARD = 'editSmartcard'
export const EMAIL_APPLICATION = 'emailApplication'
export const EXPIRED_SESSION = 'expiredSession'
export const FILL_APPLICATION = 'fillApplication'
export const FLAG_APPLICATION = 'flagApplication'
export const GENERATE_RESERVATION_INVOICE = 'generateReservationInvoice'
export const GENERATE_MONTHLY_INVOICE = 'generateMonthlyInvoice'
export const GPS_LOCATION = 'gpsLocation'
export const GET_FORM_VALUE = 'getFormValue'
export const GET_FORM_FIELD = 'getFormField'
export const IGNITION_ON = 'ignitionOn'
export const IGNITION_OFF = 'ignitionOff'
export const INVITE_DRIVER = 'inviteDriver'
export const IMMOBILIZE_VEHICLE = 'immobilizeVehicle'
export const INSTANT_RESERVATION = 'instantReservation'
export const LOAD_ADMIN_REQUEST = 'loadAdminRequest'
export const LOAD_ALL_CAR_RESULTS = 'loadAllCarResults'
export const LOAD_APPLICATION = 'loadApplication'
export const LOAD_AVAILABILITY = 'loadAvailability'
export const LOAD_CAR = 'loadCar'
export const LOAD_CAR_AVAILABILITY = 'loadCarAvailability'
export const LOAD_CAR_EXTRAS = 'loadCarExtras'
export const LOAD_CAR_FEATURES = 'loadCarFeatures'
export const LOAD_CAR_GRAPHS = 'loadCarGraphs'
export const LOAD_CAR_LIST = 'loadCarList'
export const LOAD_CAR_MESSAGES_TOTAL = 'loadCarMessagesTotal'
export const LOAD_CAR_MESSAGES = 'loadCarMessages'
export const LOAD_CAR_MESSAGES_TYPE = 'loadCarMessagesType'
export const LOAD_CONTRACT_DETAILS = 'loadContractDetails'
export const LOAD_RESERVATION_NOTES_TOTAL = 'loadReservationNotesTotal'
export const LOAD_RESERVATION_NOTES = 'loadReservationNotes'
export const LOAD_CAR_NOTES = 'loadCarNotes'
export const LOAD_CAR_NOTES_TOTAL = 'loadCarNotesTotal'
export const LOAD_CAR_DAMAGES = 'loadCarDamages'
export const LOAD_CAR_DAMAGES_TOTAL = 'loadCarDamagesTotal'
export const LOAD_CAR_RATES = 'loadCarRate'
export const LOAD_CAR_RESERVATIONS = 'loadCarReservations'
export const LOAD_CAR_RESERVATIONS_COLUMNS = 'loadCarReservationsColumns'
export const LOAD_CAR_RESERVATIONS_TOTAL = 'loadCarReservationsTotal'
export const LOAD_CAR_RESULTS = 'loadCarResults'
export const LOAD_CAR_RESULTS_TOTAL = 'loadCarResultsTotal'
export const LOAD_CAR_RESULTS_RATES = 'loadCarResultsRates'
export const LOAD_CAR_UPCOMING_RESERVATIONS = 'loadCarUpcomingReservations'
export const LOAD_CARDS = 'loadCards'
export const LOAD_DASHBOARD = 'loadDashboard'
export const LOAD_DASHBOARD_MESSAGES = 'loadDashboardMessages'
export const LOAD_FORM = 'loadForm'
export const LOAD_HELD_CHARGE = 'loadHeldCharge'
export const LOAD_HISTORY = 'loadHistory'
export const LOAD_NOTIFICATIONS = 'loadNotifications'
export const LOAD_NOTIFICATIONS_COUNT = 'loadNotificationsCount'
export const LOAD_ORGANIZATION = 'loadOrganization'
export const LOAD_PETROL_CARDS = 'loadPetrolCards'
export const LOAD_RESERVATION = 'loadReservation'
export const LOAD_RESERVATION_BREAKDOWNS = 'loadReservationBreakdowns'
export const LOAD_RESERVATIONS = 'loadReservations'
export const LOAD_SMART_CARD = 'loadSmartCards'
export const LOAD_SIDEBAR = 'loadSidebar'
export const LOAD_TICKET = 'loadTicket'
export const LOAD_TRAILING_REBATE_PROMO_DETAILS = 'loadTrailingRebatePromoDetails'
export const LOAD_USER = 'loadUser'
export const LOAD_USER_ALERTS = 'loadUserAlerts'
export const LOAD_USER_CREDIT_CARDS = 'loadUserCreditCards'
export const LOAD_USER_DRIVERS = 'loadUserDrivers'
export const LOAD_USER_DRIVERS_COLUMNS = 'loadUserDriversColumns'
export const LOAD_USER_DRIVERS_TOTAL = 'loadUserDriversTotal'
export const LOAD_USER_FILES = 'loadUserFiles'
export const LOAD_USER_FILES_TOTAL = 'loadUserFilesTotal'
export const LOAD_USER_FILES_COLUMNS = 'loadUserFilesColumns'
export const LOAD_USER_LEDGER = 'loadUserLedger'
export const LOAD_USER_LEDGER_COLUMNS = 'loadUserLedgerColumns'
export const LOAD_USER_NOTES = 'loadUserNotes'
export const LOAD_USER_NOTES_TOTAL = 'loadUserNotesTotal'
export const LOAD_USER_RESERVATIONS = 'loadUserReservations'
export const LOAD_USER_RESERVATIONS_TOTAL = 'loadUserReservationsTotal'
export const LOAD_USER_RESERVATIONS_COLUMNS = 'loadUserReservationsColumns'
export const LOCK_CAR = 'lockCar'
export const LOGIN = 'login'
export const LOGIN_AS_USER = 'loginAsUser'
export const LOGIN_USER = 'loginUser'
export const LOGOUT = 'logout'
export const MAKE_ACTIVE = 'makeActive'
export const MAKE_INACTIVE = 'makeInactive'
export const MAKE_MASTER_ACCOUNT = 'makeMasterAccount'
export const MODIFY_FORM_FIELD = 'modifyFormField'
export const MODIFY_FORM_VALUE = 'modifyFormValue'
export const MOVE_CAR = 'moveCar'
export const MOVE_TO_APPLICATIONS = 'moveToApplications'
export const NEW_MAINTENANCE = 'newMaintenance'
export const NEW_RESERVATION = 'newReservation'
export const NEW_RESERVATION_USER = 'newReservationUser'
export const OPEN_CONFIRMATION_MODAL = 'openConfirmationModal'
export const OPEN_NOTIFICATION_MODAL = 'openNotificationModal'
export const OPEN_ERROR_MODAL = 'openErrorModal'
export const OPEN_MODAL = 'openModal'
export const OPEN_LOT = 'openLot'
export const QUIT_MEMBER = 'quitMember'
export const REFRESH_LOGGED_IN_USER = 'refreshLoggedInUser'
export const REFUND_PENDING_CHARGE = 'refundPendingCharge'
export const REFUND_CHARGE = 'refundCharge'
export const REFUND_RESERVATION = 'refundReservation'
export const RELEASE_HELD_CHARGE = 'releaseHeldCharge'
export const REJOIN_MEMBER = 'rejoinMember'
export const REMOVE_DRIVER = 'removeDriver'
export const REOPEN_TICKET = 'reopenTicket'
export const REMOVE_TICKET_PRIORITY = 'removeTicketPriority'
export const REPAIR_DAMAGE = 'repairDamage'
export const REPORT_DAMAGE = 'reportDamage'
export const RESEND_RESERVATION = 'resendReservation'
export const RESERVE_CAR = 'reserveCar'
export const RESOLVE_DAMAGE = 'resolveDamage'
export const RESOLVE_NOTE = 'resolveNote'
export const RESTORE_SMARTCARD = 'restoreSmartcard'
export const RESTRICT_MEMBER = 'restrictMember'
export const SEND_CANCEL_MESSAGE = 'sendCancelMessage'
export const SEND_GUARANTOR_FORM = 'sendGuarantorForm'
export const SNOOZE_NOTIFICATION = 'snoozeNotification'
export const SNOOZE_NOTIFICATIONS = 'snoozeNotifications'
export const SUBMIT_FORM = 'submitForm'
export const DELETE_VALET = 'deleteValet'
export const TECH_PUSH_VALET = 'techPushValet'
export const TOGGLE_ALERT = 'toggleAlert'
export const TOGGLE_LOT_OVERNIGHT = 'toggleLotOvernight'
export const TOGGLE_LOT_WEEKEND = 'toggleLotWeekend'
export const TOGGLE_LOT_ONE_WAY_TRIPS = 'toggleLotOneWayTrips'
export const TOGGLE_SIDEBAR = 'toggleSidebar'
export const TRIP_DATA = 'requestTripData'
export const UNASSIGN_SMARTCARD = 'unassignSmartcard'
export const UNFLAG_APPLICATION = 'unflagApplication'
export const UNLOCK_CAR = 'unlockCar'
export const UNRESTRICT_MEMBER = 'unrestrictMember'
export const UPLOAD_FILE = 'uploadFile'
export const UPLOAD_GUARANTOR_FORM = 'uploadGuarantorForm'
export const WAIVE_MEMBERSHIP = 'waiveMembership'



// WEBPACK FOOTER //
// ./src/vuex/types.js